/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import API from 'API'


const mutations = {

  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  UPDATE_SIDEBAR_WIDTH(state, width) {
    state.sidebarWidth = width;
  },
  UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
    state.sidebarItemsMin = val;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
    state.isSidebarActive = value;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_BREAKPOINT(state, val) {
    state.breakpoint = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_USER_ROLE(state, val) {
    state.userRole = val
    localStorage.setItem('userRole', val)
  },
  // UPDATE_STATUS_CHAT(state, value) {
  //     state.AppActiveUser.status = value;
  // },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },

  SAVE_STAGE(state, stage) {
    let background;
    for (const item of stage.children[1].children) {
      if (item.attrs.type == 'background') {
        background = {
          item: item,
          bg_id: item.attrs.bg_id,
          width: item.width(),
          height: item.height()
        };
      }
    }
    
    let def = (new Promise( (resolve, reject)=>resolve()||reject() ))
    for (const item of stage.children[1].children) {
      let type = item.attrs.type;
      if (type == 'text') {
        let req = getTextRequest(item, background);
        def = def.then( ()=>API.projects.saveText(req) );
      } else if (type == 'button') {
        let req = getBtnRequest(item, background);
        def = def.then( ()=>API.projects.saveButton(req) );
      } else if (type == 'image') {
        let req = getImageRequest(item, background);
        def = def.then( ()=>API.projects.saveImage(req) );
      } else if (type == 'video') {
        let req = getVideoRequest(item, background);
        def = def.then( ()=>API.projects.saveVideo(req) );
      } else if (type == 'gift') {
        let req = getGiftRequest(item, background);
        def = def.then( ()=>API.projects.saveGift(req, item && item.attrs && item.attrs.id).then( e=>item.id(e.data.id) ) ); //console.log( 'Updating GIFT ID',e, item.id())
      } else if (type == 'price') {
        let req = getPriceRequest(item, background);
        def = def.then( ()=>API.projects.savePrice(req, item && item.attrs && item.attrs.id).then( e=>item.id(e.data.id) ) ); //console.log( 'Updating Price ID',e, item.id())
      } else if (type == 'subscribe') {
        let req = getSubscribeRequest(item, background);
        def = def.then( ()=>API.projects.saveSubscribe(req, item && item.attrs && item.attrs.id).then( e=>item.id(e.data.id) ) ); //console.log( 'Updating Subscribe ID',e, item.id())
      }
      
    }
    def.then(stage.callback)
    
  },
  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index)
    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.index == payload.index)
      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // The Navbar
  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })
    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

}


function getTextRequest (self, background) {
  //debugger;
  const req = {
    bg_id: background.bg_id,
    rotation: self.rotation().toFixed(0),
    width: translateLength( background.width, self.children[0].width() ),
    fontSize: self.children[1].attrs.fontSize,
    font: self.children[1].attrs.fontFamily || '',
    align: self.children[1].align(),
    color: self.children[1].fill(),
    text: self.children[1].attrs.text,
    background: self.children[0].fill(),
    type: self.attrs.type,
    name: self.children[1].attrs.name,
    x: translateAxisX(background.item, self) ,
    y: translateAxisY(background.item, self),
    zindex: self.zIndex()
  }
  return req;
}

function getImageRequest (self, background) {

  self.width( self.width()*self.getScale().x );
  self.height( self.height()*self.getScale().y );
  self.setScaleX(1);
  self.setScaleY(1);

  const req = {
    bg_id: background.bg_id,
    rotation: self.rotation().toFixed(0),
    width: translateLength(background.width, self.width()),
    height: translateLength(background.height, self.height()),
    name: self.attrs.name,
    image_url: self.attrs.src,
    scaleX: translateLength(background.width, self.width()),
    scaleY: translateLength(background.height, self.height()),
    type: self.attrs.type,
    x: translateAxisX(background.item, self),
    y: translateAxisY(background.item, self),
    zindex: self.zIndex()
  }
  return req;
}

function getVideoRequest(self, background) {
  
  self.width( self.width()*self.getScale().x );
  self.height( self.height()*self.getScale().y );
  self.setScaleX(1);
  self.setScaleY(1);

  const req = {
    bg_id: background.bg_id,
    rotation: self.rotation(),
    width: translateLength(background.width, self.width()),
    height: translateLength(background.height, self.height()),
    video_url: self.attrs.url,
    video_src: self.attrs.src,
    name: self.attrs.name,
    scaleX: translateLength(background.width, self.width()),
    scaleY: translateLength(background.height, self.height()),
    type: self.attrs.type,
    x: translateAxisX( background.item, self),
    y: translateAxisY( background.item, self),
    zindex: self.zIndex()
  }
  return req;
}

function getBtnRequest(self, background) {
  const req = {
    bg_id: background.bg_id,
    rotation: self.rotation().toFixed(0),
    width: translateLength(background.width, self.children[1].width()),
    height: translateLength(background.height, self.children[1].height()),
    btn_type: self.attrs.type,
    name: self.attrs.name,
    btn_type_value: self.attrs.url,
    border_width: self.children[0].attrs.strokeWidth,
    border_color: self.children[0].attrs.stroke,
    fontSize: self.children[1].attrs.fontSize,
    font: self.children[1].attrs.fontFamily || '',
    align: self.children[1].align(),
    color: self.children[1].fill(),
    background: self.children[0].fill(),
    type: self.attrs.type,
    text: self.children[1].attrs.text,
    x: translateAxisX( background.item, self),
    y: translateAxisY( background.item, self),
    zindex: self.zIndex()
  }
  return req;
}

function getGiftRequest(self, background){
  const req = {
    //id: self.attrs.id,
    bg_id: +background.bg_id,
    type: self.attrs.type,
    color: self.children[3].attrs.fill, 
    text: self.children[1].attrs.text,
    name: self.children[2].attrs.text,
    button_url: self.children[3].attrs.button_url,
    button_hook_url: self.children[3].attrs.button_hook_url
  }
  window.popo = self.children;
  return req;
}
function getPriceRequest(self, background){
  window.sese = self;
  const req = {
    //id: self.attrs.id,
    bg_id: +background.bg_id,
    type: self.attrs.type,
    color: self.children[3].attrs.fill, 
    text: self.children[1].attrs.text,
    text_price: +self.children[2].attrs.text.split(' руб.')[0],//int
    button_text: self.children[4].attrs.text,
  }
  return req;
}
function getSubscribeRequest(self, background){
  window.sese = self;
  const req = {
    //id: self.attrs.id,
    bg_id: +background.bg_id,
    type: self.attrs.type,
    specialist_id: self.attrs.specialist_id,
    date: self.children[5].attrs.text,
    action: '/',

  }
  return req;
}

function translateAxisX(bk, elem) {

  var half;
  half = ( elem.width() || (elem.children && elem.children[0] && elem.children[0].width() ) ) / 2

  if (elem.attrs && elem.attrs.type =='text')
    half = elem.children[1].getWidth() / 2;
  
  var bk_x = bk.x() + bk.width()/2;
  var x = (elem.x() + half) - bk_x;
  x = Math.round(x); 
  // console.log('Сохранение координат обьекта \n\r%cAxisX - mutations.js ' + x + ' half= ' + half,'color:skyblue;');
  return x * 200 / bk.width();
}

function translateAxisY(bk, elem) {

  var half;
  half = ( elem.height() || (elem.children && elem.children[0] && elem.children[0].height() ) ) / 2
  
  if (elem.attrs && elem.attrs.type =='text')
    half = elem.children[1].getHeight() / 2;

  var bk_y = bk.y() + bk.height()/2;
  var y = -(elem.y() + half) + bk_y; 
  y = Math.round(y);
  // console.log('%cAxisY - mutations.js ' + y + ' half=' + half,'color:skyblue;');
  return y * 200 / bk.height();
}

function translateLength(bg_width, width) {
  return width * 100 / bg_width;
}


export default mutations
